import React, { useEffect, useRef, useState } from "react";
import "./Art.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Art = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Digital Art Platforms",
      description: "Comprehensive digital systems for artists to showcase and sell their work",
      whatsappMessage: "Hello, I'm interested in Digital Art Platforms consultation.",
    },
    {
      id: 2,
      title: "Art Gallery Management",
      description: "Digital solutions for managing gallery collections, exhibitions, and sales",
      whatsappMessage: "Hello, I'm interested in Art Gallery Management consultation.",
    },
    {
      id: 3,
      title: "Art Market Analytics",
      description: "Data-driven insights for art valuation, trends, and market predictions",
      whatsappMessage: "Hello, I'm interested in Art Market Analytics consultation.",
    },
    {
      id: 4,
      title: "Virtual Exhibition Tools",
      description: "Immersive digital experiences for online art exhibitions and viewings",
      whatsappMessage: "Hello, I'm interested in Virtual Exhibition Tools consultation.",
    },
    {
      id: 5,
      title: "Art Community Engagement",
      description: "Solutions to connect artists, collectors, and enthusiasts",
      whatsappMessage: "Hello, I'm interested in Art Community Engagement consultation.",
    },
    {
      id: 6,
      title: "Art Authentication Technology",
      description: "Blockchain and AI solutions for art provenance and authentication",
      whatsappMessage: "Hello, I'm interested in Art Authentication Technology consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="art-sector-page">
      <Helmet>
        <title>
          Art Sector Technology Solutions | Innovative Art Industry Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive art technology solutions including digital art platforms, gallery management systems, art market analytics, and virtual exhibition tools."
        />
        <meta
          name="keywords"
          content="art technology, digital art platforms, gallery management, art analytics, virtual exhibitions, art authentication, art community, art solutions, art market technology, digital art, art innovation, art apps, art data, art sector SaaS, art industry management, art digital transformation"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="art-sector-hero">
        <div className="art-sector-hero-content">
          <h1 className="art-sector-hero-title">
            Revolutionizing <span className="art-sector-highlight">The Art World</span>
          </h1>
          <p className="art-sector-hero-description">
            We deliver cutting-edge art technology solutions that transform how art is created, exhibited, sold, and experienced. From digital platforms to gallery management systems and AI-powered art authentication.
          </p>
          <div className="art-sector-hero-buttons">
            <a href="/contact-us">
              <button className="art-sector-btn art-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="art-sector-btn art-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="art-sector-hero-visual">
          <div className="art-sector-animated-canvas">
            <div className="art-sector-color-splash"></div>
            <div className="art-sector-paint-brush"></div>
            <div className="art-sector-art-grid"></div>
          </div>
          <div className="art-sector-orb art-sector-orb-1"></div>
          <div className="art-sector-orb art-sector-orb-2"></div>
          <div className="art-sector-orb art-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="art-sector-services">
        <div className="art-sector-services-header">
          <h2 className="art-sector-section-title">
            Our Art Technology Solutions
          </h2>
          <p className="art-sector-section-subtitle">
            Innovative art technology services designed to transform the art industry, enhance gallery experiences, and connect artists with global audiences.
          </p>
        </div>

        <div className="art-sector-services-grid">
          {/* Digital Art Platforms Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-digital"></div>
            </div>
            <h3>Digital Art Platforms</h3>
            <p>
              Comprehensive digital systems for artists to showcase, sell, and manage their artwork.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Portfolio Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>E-commerce Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Commission Systems</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Secure Transactions</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Sales Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Gallery Management Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-gallery"></div>
            </div>
            <h3>Art Gallery Management</h3>
            <p>
              Digital solutions for managing gallery collections, exhibitions, and client relationships.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Inventory Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Exhibition Planning</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Client CRM</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Sales Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">85%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Art Analytics Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-analytics"></div>
            </div>
            <h3>Art Market Analytics</h3>
            <p>
              Data-driven insights for art valuation, market trends, and investment opportunities.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Market Trends</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Valuation Models</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Investment Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Custom Reports</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Analysis</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Virtual Exhibitions Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-virtual"></div>
            </div>
            <h3>Virtual Exhibition Tools</h3>
            <p>
              Immersive digital experiences for online art exhibitions and virtual gallery tours.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>3D Gallery Spaces</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>VR/AR Compatibility</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interactive Viewing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Live Event Streaming</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">5x</div>
                <div className="stat-label">Audience Reach</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">80%</div>
                <div className="stat-label">Engagement Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Community Engagement Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-community"></div>
            </div>
            <h3>Art Community Platforms</h3>
            <p>
              Solutions to connect artists, collectors, galleries, and art enthusiasts worldwide.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Social Features</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Event Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Collaboration Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Networking Features</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Connection Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">75%</div>
                <div className="stat-label">Active Users</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Authentication Technology Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-authentication"></div>
            </div>
            <h3>Art Authentication Technology</h3>
            <p>
              Blockchain and AI solutions for art provenance, verification, and authentication.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Provenance Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Certificates</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>AI Authentication</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Blockchain Security</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Accuracy</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Tamper-Proof</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Art Education Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-education"></div>
            </div>
            <h3>Art Education Platforms</h3>
            <p>
              Comprehensive learning management systems for art schools and online education.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Course Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Virtual Classes</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Student Portfolios</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Progress Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Learning Efficiency</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">90%</div>
                <div className="stat-label">Satisfaction Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Art AI Card */}
          <div className="art-sector-service-card">
            <div className="art-sector-service-icon">
              <div className="art-sector-icon art-sector-icon-ai"></div>
            </div>
            <h3>Art AI & Creative Tools</h3>
            <p>
              AI-powered solutions for art creation, style transfer, and creative inspiration.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Style Transfer</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Creative Assistance</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Art Generation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Technical Analysis</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Creativity Boost</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Time Saved</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="art-sector-services-cta">
          <h3>Ready to transform your art business?</h3>
          <p>
            Schedule a free consultation with our art technology experts to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="art-sector-consultation-container">
              <button
                className="art-sector-primary-btn art-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="art-sector-modal-overlay">
                  <div className="art-sector-modal-content">
                    <button
                      className="art-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="art-sector-modal-title">
                      Art Technology Consultation
                    </h2>
                    <p className="art-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="art-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`art-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="art-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="art-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`art-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="art-sector-btn art-sector-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="art-sector-stats">
        <div className="art-sector-stats-container">
          <div className="art-sector-stat">
            <h3 className="art-sector-stat-number" data-count="150">
              150
            </h3>
            <p className="art-sector-stat-label">Art Projects</p>
          </div>
          <div className="art-sector-stat">
            <h3 className="art-sector-stat-number" data-count="95">
              125
            </h3>
            <p className="art-sector-stat-label">Client Satisfaction</p>
          </div>
          <div className="art-sector-stat">
            <h3 className="art-sector-stat-number" data-count="12">
              11
            </h3>
            <p className="art-sector-stat-label">Years Experience</p>
          </div>
          <div className="art-sector-stat">
            <h3 className="art-sector-stat-number" data-count="30">
              30
            </h3>
            <p className="art-sector-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="art-sector-cta">
        <div className="art-sector-cta-content">
          <h2>Ready to Transform Your Art Business?</h2>
          <p>
            Contact us today to discuss how our art technology expertise can help your organization innovate and reach new audiences.
          </p>
          <a href="/contact-us">
            <button className="art-sector-btn art-sector-btn-primary art-sector-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Art;